<template>
    <div class="message" :class="'message_' + type">
        <div class="message__icon">
            <img v-if="type === 'error'" src="/img/svg/error_icon.svg" alt="Ошибка">
            <img v-if="type === 'warning'" src="/img/svg/warning_icon.svg" alt="Внимание">
            <img v-if="type === 'info'" src="/img/svg/info_icon.svg" alt="Информация">
            <img v-if="type === 'success'" src="/img/svg/success_icon.svg" alt="Успешно">
        </div>
        <h3 class="title message__title">{{ title }}</h3>
        <div class="message__text">
          <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'app-message',
  props: {
    type: String,
    title: String
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/vars';
@import '../../../assets/css/system/mixins';

.message {
  position: relative;
  width: 100%;
  max-width: 900px;
  padding: 20px 20px 20px 60px;
  border: 1px solid $border_color;
  border-radius: 3px;
  animation: fadeIn .3s ease-in;

  &__icon {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  &__title {
    color: $font_color_second;
    padding-bottom: 0;
  }

  &__text {
    width: 100%;
    max-width: 760px;
  }

  &_error {
    border: 1px solid $color_error;

    .message__title {
      color: $color_error;
    }
  }

  &_warning {
    border: 1px solid $color_warning;

    .message__title {
      color: $color_warning;
    }
  }

  &_info {
    border: 1px solid $color_info;

    .message__title {
      color: $color_info;
    }
  }

  &_success {
    border: 1px solid $color_success;

    .message__title {
      color: $color_success;
    }
  }
}
</style>
